export const PAGE_TEXT = {
  TITLE: 'Nomination',
  INTERVIEW_PANEL: 'Interview Panel',
  PENDING_NOTE: `The application remains in your To-Do List as it is pending declarations from other members of the supervisory team. Once all members have submitted their declarations, the application will be removed from your list and forwarded to the DoPRgS for assessment.`,
  ACCESS_DENIED: {
    TITLE: 'Access Denied',
    CONTENT_1: `Oops! It appears that you are not the proposed supervisor`,
    CONTENT_2: `for this application.`,
    BACK_HOME: `Therefore, you do not have the permission to view the details of this nomination. Please return to the <a href="/internal/nominations/application-list">homepage.</a>`,
  },
  DISABLE_EVALUATION_TIP: `Please note that this applicant is exempted from the Scholarship Evaluation process. Kindly proceed to click "submit" once you have completed the nomination.`,
  POLISH_LIST: 'Full Nomination List',
  POLISH_COMMENTS: 'Polish Comments',
  REFEREE_REPORT_SELECTION: 'Referee Report Selection',
  PLAGIARISM_CHECKING: 'Plagiarism Checking',
  CHIEF_SUPERVISOR: {
    TITLE: 'Supervisors',
    APPLICANT_INFORMATION: {
      TITLE: 'Applicant Information',
      APPLICATION_NO: 'Application No.',
      APPLICANT_NAME: 'Applicant Name',
      ENTRY_YEAR: 'Entry Year',
      PROGRAMME_TYPE: 'Programme Type',
      PROGRAMME: 'Programme',
      DEPARTMENT: 'Department',
      RESEARCH_AREA: 'Research Area',
      PARTNER_INSTITUTION: 'Partner University/Institution',
      CHIEF_SUPERVISOR_OF_PARTNER_INSTITUTION:
        'Chief Supervisor of Partner University/Institution',
      PROPOSED_SUPERVISOR: 'Proposed Chief Supervisor',
      RESEARCH_AREA_OPTIONAL: 'Research Area 2',
      PROPOSED_CHIEF_SUPERVISOR_OPTIONAL: 'Proposed Chief Supervisor 2',
    },
    CHIEF_SUPERVISOR: {
      TITLE: 'Chief Supervisor',
      NET_ID: 'Net ID',
      SUPERVISOR_TITLE: 'Title',
      JOB_TITLE: 'Job Position',
      NAME: 'Name',
      DEPARTMENT: 'Department',
      EMAIL: 'Email',
      PREVIOUS_SUCCESSFUL_SUPERVISION:
        'Has previous successful supervision experience',
      DSRC_CHAIR: 'D/SRC Chair',
      DORPGS: 'DoRPgS',
      TAKE_INTERVIEW: 'I confirmed that the applicant has taken the interview',
      GIVEN_NAME: 'Given Name',
      SURNAME: 'Surname',
      HINT: `Please contact GS (<a href="mailto:gs.it@polyu.edu.hk">gs.scholarship@polyu.edu.hk</a>) to change the chief supervisor for awardee under competitive schemes (except HKPFS).`,
    },
  },
  SUPERVISOR_TEAM: {
    TITLE: 'Supervisor Team',
    ANY_SUPERVISOR: 'If there are any other supervisor?',
    ROLE: 'Role',
    HINT: 'Please click the + on the right to fill in more information.',
    ROLE_TYPE: {
      CO_SUPERVISOR: 'PolyU Co-supervisor',
      EXTERNAL_CO_SUPERVISOR: 'External Co-supervisor',

      EXTERNAL_CHIEF_JOINT:
        'Co-supervisor of Partner University/Institution (Joint PhD Supervision Programmes Leading to a PolyU Degree)',
      EXTERNAL_CHIEF_DUAL:
        'Chief Supervisor of Partner University (Dual PhD Degree Programmes)',

      /**
       * keep following fields for compatibility with older data in supervisor team section
       * EXTERNAL_CHIEF_SUPERVISOR -> EXTERNAL_CHIEF_DUAL
       * CHIEF_SUPERVISOR -> EXTERNAL_CHIEF_JOINT
       * */
      EXTERNAL_CHIEF_SUPERVISOR:
        'Chief Supervisor of Partner University (Dual PhD Degree Programmes)',
      CHIEF_SUPERVISOR:
        'Co-supervisor of Partner University/Institution (Joint PhD Supervision Programmes Leading to a PolyU Degree)',
    },
    SUPERVISOR: {
      TITLE: 'Title',
      JOB_TITLE: 'Job Position',
      NET_ID: 'Net ID',
      GIVEN_NAME: 'Given Name',
      SURNAME: 'Surname',
      NAME: 'Name',
      DEPARTMENT: 'Department',
      EMAIL: 'Email',
      INSTITUTION: 'Institution',
      PREVIOUS_SUCCESSFUL_SUPERVISION:
        'Has previous successful supervision experience',
      DRC_MEMBER: 'D/SRC Chair',
      DORPGS_MEMBER: 'DoRPgS',
    },
  },
  GSB1_FORM: {
    TITLE: 'Admission Requirement',
    SUGGEST_OFFER: 'Qualification Check',
    GENERAL_ENTRANCE: 'General Entrance: ',
    ENGLISH_LANGUAGE: 'English Language: ',
    PHD: 'PhD',
    MPHIL: 'MPhil',
    SUBMIT_CONFIRM: {
      TITLE: 'Not recommended Programme',
      CONTENT:
        'The programme you choose does not match with the suggest offer. Are you sure to save the form?',
    },
    SUBTITLE: 'Admission Requirement',
    OFFER_PROGRAMME: 'Programme to be offered',
    PROGRAMME_TYPE: {
      TWO_YEAR_FULL_TIME_MPHIL: '2-year Full-time MPhil',
      FOUR_YEAR_PART_TIME_MPHIL: '4-year Part-time MPhil',
      THREE_YEAR_FULL_TIME_PHD: '3-year Full-time PhD',
      SIX_YEAR_PART_TIME_PHD: '6-year Part-time PhD',
      FOUR_YEAR_FULL_TIME_PHD: '4-year Full-time PhD',
      EIGHT_YEAR_PART_TIME_PHD: '8-year Part-time PhD',
    },
    ENTRANCE_REQUIREMENT: 'General Entrance Requirement',
    ENTRANCE_REQUIREMENT_JUSTIFICATION:
      '*for applicant who meets the admission requirements for a 3-year full-time/6-year part-time PhD programme, please provide justifications for admission to a 4-year full-time/8-year part-time PhD:',

    // entrance requirement text map
    ENTRANCE_REQUIREMENT_TYPE: {
      SECOND_CLASS_BACHELOR:
        "Have or will have a Bachelor's degree with Second Class Honours or above",
      EQUAL_SECOND_CLASS_BACHELOR:
        "Have or will have a Bachelor's degree equivalent to Second Class Honours or above",
      MPHIL: "Have or will have a MPhil's degree",
      DISSERTATION_MASTER:
        "Have or will have a Master's degree with a dissertation as an award requirement",
      FIRST_CLASS_BACHELOR:
        "Have or will have a Bachelor's degree with First Class Honours",
      EQUAL_FIRST_CLASS_BACHELOR:
        "Have or will have a Bachelor's degree equivalent to First Class Honours",
      MASTER: "Have or will have a Master's degree",
    },
    LANGUAGE_REQUIREMENT: 'English Language Requirement',

    // language requirement text map
    LANGUAGE_REQUIREMENT_TYPE: {
      ENGLISH_TEST_RESULT: 'Have or will have valid English test results',
      LANGUEGE_PROOF:
        'Obtained or will obtain a degree for which English was the language of instruction with proof',
    },
    NOT_MEET_REQUIREMENT: 'Not meet the above requirements',
    JUSTIFICATION:
      'Justification for Admission of the Applicant not Meeting General Entrance Requirements or English Language Requirements (Not applicable to admission under UPSF)',
    NOTIFICATION: {
      LANGUAGE_REQUIREMENT_UNFILLED:
        'Please complete the General Entrance Requirement.',
      ENTRANCE_REQUIREMENT_UNFILLED:
        'Please complete the English Language Requirement.',
    },
  },
  SCHOLARSHIP_NOMINATION: 'Scholarship Nomination',
  EVALUATION: {
    TITLE: 'Scholarship Evaluation',
  },
  DECLARATION: {
    TITLE: 'Declaration(s)',
    CO_SUPERVISOR_TITLE:
      'Declaration by Supervisoy Team and Chief Supervisor of Partner Institution',
    FORALL: {
      DECLARATION_1:
        'I do NOT have any relationship that may constitute a conflict of interest, whether actual, potential or perceived one, with the applicant and shall declare once any conflict of interest situation arises.',
      DECLARATION_1_SUB: 'Declaration of Interests',
      DECLARATION_2:
        'I do NOT register or will not register for a higher degree that its studies overlap with this research.*',
      DECLARATION_3:
        'All information submitted is TRUE and ACCURATE and I understand that nominations with missing, incomplete and / or inaccurate information will not be considered.*',
    },
    FORHKPFS: {
      DECLARATION_4:
        'The applicant has met the recommendation threshold for HKPFS and understand that applicants failing to meet the threshold will risk disqualification.*',
    },
    FOREXTERNALORDEA: {
      DECLARATION_5:
        "(1) the funds specified above are adequate to support, at least, the student's first year of study;<br>(2) I will provide additional funding from the same funding source in case of an increase in stipend as decided by the Graduate School Board;<br>(3) the area of study of the student is closely related to that of the grant <em>(if applicable)</em>; and<br>(4) the duration of the grant <em>(if applicable)</em> is also long enough to cover the student’s first year of study.*",
    },
    FORDUAL_PHD: {
      DECLARATION_6:
        'I did not have any research collaboration with the proposed Chief Supervisor of the Partner Institution.*',
    },
    VALIDATION:
      'Please tick all declarations or fill in the justification if required',
  },
  REMARKS: {
    TITLE: 'Remarks',
    SUBTITLE_GS: 'Remarks from GS ',
    SUBTITLE_DORPGS: 'Remarks from DoRPgS ',
    SUBTITLE: 'Remarks to DoRPgS (if any)',
  },
  FUNDING: {
    TITLE: 'Funding Scheme',
    UPSF_INDICATION:
      'For each Chief Supervisor, the maximum number of studentship years funded by all competitive schemes under UPSF, except for HKPFS, is capped at 18, including both awardees and current PhD students within their normal study period. One studentship year will be released upon utilisation or a student withdraws from the programme before completion.',
    STUDENTSHIPS_FUNDED_BY_UPSF:
      'Please indicate the current studentship <b>years</b> funded by all competitive schemes under UPSF (except for HKPFS). For example, the current academic year is 2024/25, the studentship years that fall within the 2024/25 academic year and the upcoming years will be counted.',
    UPDATE_SUCCESS:
      'For certain funding options, you will need to provide a funding account and submit relevant proof documents.',
    DISCIPLINES: 'Disciplines',
    NOTICE: `Please select your <b>Funding Type</b> and choose the appropriate funding scheme(s).`,
    FUNDING_SELECTION: 'Funding Type',
    MUITI_OPTIONS:
      '*Select One or More (Only the scholarship(s) applied by the applicant will be available for your nomination.)',
    ONE_OPTIONS: '*Select One',
    CONFIRM: 'Confirm',
    CHANGE_FUNDING_DIALOG: {
      TITLE: 'Are you sure you want to update your funding plans?',
    },
  },
  FUNDING_SOURCE: {
    TITLE: 'Funding Source',
    CHECK_1:
      'Please ensure that the dates entered in the funding plans cover at least consecutive 12 months. (Format of account code: X-XXXX)',
    CHECK_2:
      'Please review the funding sources. The total duration of the provided accounts cannot cover the studentship duration.',
    CONFIRM: 'Confirm',
    CHECK_AGAIN: 'Back to Review',
    TYPE: {
      LABEL: 'Funding Type',
      VALUES: {
        COMPETITIVE: 'Competitive',
        INCENTIVE: 'Incentive',
        OTHER: 'Others',
      },
      HKPFS: 'Recommend for HKPFS?',
    },
    FUNDING_SCHEME: {
      LABEL: 'Funding Scheme',
      VALUES: {
        HONGKONG_PHD_FELLOWSHIP_SCHEME:
          'Hong Kong PhD Fellowship Scheme (HKPFS)',
        POLYU_PRESIDENTIAL_PHD_FELLOWSHIP_SCHEME:
          'PolyU Presidential PhD Fellowship Scheme (PPPFS)',
        POLYU_COMPETITIVE_PHD_FELLOWSHIP_SCHEME:
          'PolyU Competitive PhD Funding',
        COMPETITIVE_3_PLUS_1_MATCHING_FUND_AND_PPPFS:
          'Competitive 3+1 Matching Fund',
        INCENTIVE_GRF_ECS_3_PLUS_1_MATCHING_FUND:
          'Incentive GRF/ECS 3+1 Matching Fund',
        STRATEGIC_HIRING_SCHEME: 'Strategic Hiring Scheme (SHS)',
        GLOBAL_STEM_PROFESSORSHIP_SCHEME:
          'Global STEM Professorship Scheme (STEM)',
        INCENTIVE_HKPFS: 'Incentive for Chief Supervisors of HKPFS Awardees',
        INCENTIVE_DUAL_PHD_DEGREE_PROGRAMME:
          'Dual PhD Degree Programmes (Department Level)',
        NON_STEM_NON_SHS_NEW_RECRUITS: 'Non-STEM / Non-SHS / New Recruits',
        RESEARCH_UNIT:
          'Pair Research Institutes Centres (RI/RC) / State Key Labs (SKL) / Chinese National Engineering Research Centre (CNERC)',
        RIO: 'Allocation of PhD Places for Awardees of Major/ Renowned Funding and Award Schemes Managed by RIO',
        COLLABORATIVE_PHD_TRAINING_PROGRAMME:
          'Joint PhD Supervision Programmes Leading to a PolyU Degree',
        DUAL_PHD_DEGREE_PROGRAMME:
          'Dual PhD Degree Programmes (University Level)',
        EXTERNAL_GRANTS_FUNDS: 'External Grants / Funds',
        INTERNAL_GRANTS_FUNDS: 'Internal Grants / Funds',
        DEPARTMENTAL_EARNINGS_ACCOUNT: 'Departmental Earnings Account',
        ALLOCAION_PHD_FOR_MAJOR_RENOWNED_FUNDING_AND_RIO:
          'Allocation of PhD places for awardees of Major/ Renowned Funding and Award Schemes managed by RIO',
        SELF_FINANCED: 'Self-financed',
        INTERNATIONAL_PHD_FELLOWSHIP_SCHEME:
          'International PhD Fellowship Scheme (IPFS)',
      },
      ABBV: {
        HONGKONG_PHD_FELLOWSHIP_SCHEME: 'HKPFS',
        POLYU_PRESIDENTIAL_PHD_FELLOWSHIP_SCHEME: 'PPPFS',
        INTERNATIONAL_PHD_FELLOWSHIP_SCHEME: 'IPFS',
        POLYU_COMPETITIVE_PHD_FELLOWSHIP_SCHEME:
          'PolyU Competitive PhD Funding',
        COMPETITIVE_3_PLUS_1_MATCHING_FUND_AND_PPPFS:
          'Competitive 3+1 Matching Fund',
        INCENTIVE_GRF_ECS_3_PLUS_1_MATCHING_FUND:
          'Incentive GRF/ECS 3+1 Matching Fund',
        STRATEGIC_HIRING_SCHEME: 'Strategic Hiring Scheme (SHS)',
        GLOBAL_STEM_PROFESSORSHIP_SCHEME:
          'Global STEM Professorship Scheme (STEM)',
        INCENTIVE_HKPFS: 'Incentive for Chief Supervisors of HKPFS Awardees',
        INCENTIVE_DUAL_PHD_DEGREE_PROGRAMME:
          'Dual PhD Degree Programmes (Department Level)',
        NON_STEM_NON_SHS_NEW_RECRUITS: 'Non-STEM / Non-SHS / New Recruits',
        RESEARCH_UNIT:
          'Pair Research Institutes Centres (RI/RC) / State Key Labs (SKL) / Chinese National Engineering Research Centre (CNERC)',
        RIO: 'Allocation of PhD Places for Awardees of Major/ Renowned Funding and Award Schemes Managed by RIO',
        COLLABORATIVE_PHD_TRAINING_PROGRAMME:
          'Joint PhD Supervision Programmes Leading to a PolyU Degree',
        DUAL_PHD_DEGREE_PROGRAMME:
          'Dual PhD Degree Programmes (University Level)',
        EXTERNAL_GRANTS_FUNDS: 'External Grants / Funds',
        INTERNAL_GRANTS_FUNDS: 'Internal Grants / Funds',
        DEPARTMENTAL_EARNINGS_ACCOUNT: 'Departmental Earnings Account',
        ALLOCAION_PHD_FOR_MAJOR_RENOWNED_FUNDING_AND_RIO:
          'Allocation of PhD places for awardees of Major/ Renowned Funding and Award Schemes managed by RIO',
        SELF_FINANCED: 'Self-financed',
      },
    },
    ROUND: {
      LABEL: 'Round',
    },
    ACCOUNT: {
      CONFIRM: `I hereby confirm that I will allocate sufficient funding for this applicant's program.`,
      LABEL: 'Funding Account',
      ERROR_HINT:
        'Please adjust the dates to ensure they span a minimum of 12 months.',
      HINT: 'Please ensure that the dates entered in the funding plans cover at least consecutive 12 months. (Format of account code: X-XXXX)',
      CODE: 'Account code',
      FROM: 'From',
      TO: 'To',
      PERIOD: 'Period',
      PANEL: {
        ONE: 'The Panel decided to provide',
        TWO: ' studentship year(s) for this applicant according to the proposed offering programme. Chief Supervisor is required to match the remaining studentship years.',
      },
      RIO_CONFIRM: `I have informed the <a href='https://www.polyu.edu.hk/rio/polyu_all_staff_students/service-contact/' target="_blank" rel="noopener noreferrer">Research Innovation Office</a> / Finance Office to reserve sufficient funding in the stipend budget head for the account(s) provided above.`,
      EXTERNAL_GRANT_CONFIRM:
        'I have sufficient funding from my own external grants or non-UGC funding or have obtained approval from the account owner of my Department/School to match the remaining studentship year(s) of the student.',
      INFO_ACCURATE_CONFIRM:
        'I acknowledge my responsibility to ensure that all account information submitted is accurate, and I understand inaccurate information will lead to a delayed offer',
      MAKEUP_HINT:
        'You are suggested to provide a preliminary funding plan for the entire study period. For the Central funded period, please indicate “Central”.',
    },
    POLYU_COMPETITIVE_CONFIRM:
      'I understand that the University will provide different levels of financial support for each recommended application on a competitive basis. The supervisor is required to top up with the remaining number of studentship years from his/her own external grants or non-UGC funding which can be provided by his/her Department/School. For successful applications, the supervisor will be asked to provide the account code after the panel decision.',
    PANEL: {
      LABEL: 'Panel',
      VALUES: {
        SCIENCES_MEDICINE_ENGINEERING_TECHNOLOGY:
          'Science, Medicine, Engineering and Technology',
        HUMANITIES_SOCIAL_SCIENCES_BUSINESS_STUDIES:
          'Humanities, Social Sciences and Business Studies',
        MIXED: 'Mixed',
      },
    },
    DOCS: {
      LABEL: 'Required Documents',
      DESC: `Two strong referees' reports/reference letters in English`,
      UPLOAD:
        'Upload Remark: Only accept one PDF file without any password or encryption.',
    },
    BONUS: {
      LABEL: 'Bonus',
      NOTE: 'No double count is allowed',
      VALUES: {
        MASTER_MPHIL_DEGREE:
          'Master/MPhil degree from UL5 with GPA/class ranking of AL6 or above',
        WORK_EXPERIENCE:
          'Professional or research-related work experience (e.g. work experience as research personnel/professional practitioners, conference presentations as 1st or 2nd author and patents)',
        COMMUNITY_SERVICE:
          'Professional-related community service/qualification(licenses) (only community service/qualification(license) that is professionally related to the research study counts)',
        EXHIBITIONS_AND_PERFORMANCES:
          'Prestigious exhibitions and performances (e.g. design product exhibitions or performing art shows that are related to the research study)',
        BEST_PAPER:
          'Best paper awards at national/international conferences (Only 1st or 2nd author counts)',
      },
      JUSTIFICATION: 'Justification',
      SUPPORTING_DOC: 'Supporting Document',
    },
    RECOMMENDATION: {
      TITLE: 'Recommendation',
      URL: 'https://www.polyu.edu.hk/gs/polyu_all_staff/upsf/',
      WARNING:
        'Please highlight all good attributes of the HKPFS applicant with specific information.',
      PARAGRAPH_1:
        'Recommendation to support this nomination (in point form, max 150 words).',
      PARAGRAPH_2: 'Please refer to the',
      FRAMEWORK: 'Framework',
      PARAGRAPH_3:
        'and your departmental discipline-specific list for reference. Please contact  your DoRPgS for the list.',
    },
    ROLE: {
      LABEL: 'Role',
      MY_ROLE: 'My role in the Project',
      CI: {
        CONFIRMATION:
          'I confirm that I have sought the PI’s consent for using the incentive and the project funding to admit the student, and the PI is the Co-supervisor of the student.',
        DESC: 'The use of the incentive is normally for the PI of the project as Chief Supervisor only. Please provide justifications for consideration on a case-by-case basis if PI uses the incentive as a Co-Supervisor.',
        LABEL: 'Co-PI',
      },
      PI: {
        LABEL: 'PI',
        NAME: 'Name of PI',
        DEPARTMENT: 'Department/Shool of PI',
        JUSTIFICATION: 'Justification',
      },
    },
    SHS_ROLE: {
      CONFIRMATION_1:
        'All information submitted is true and accurate and I understand that nominations with missing, incomplete and/or inaccurate information will not be considered.',
    },
    PROOF_OF_INCENTIVE_CATEGORIES: {
      TITLE: 'Proof of Incentive Scheme & Strategic Allocation Categories',
      HINTS: {
        HINT_1: 'GRF/ECS Incentive: The project record in PGMS',
        HINT_2:
          'Chief Supervisors of HKPFS Awardees: The email notification from GS',
        HINT_3: 'STEM/SHS: The email of account set-up from RIO',
        HINT_4:
          'PAIR Research Institutes/ Centres (RI/ RC)/ State Key Labs (SKL)/ Chinese National Engineering Research Centres (CNERC): The email notification from the Research Unit',
        HINT_5:
          'Allocation to Awardees of Major/Renowned Funding and Award Schemes: The email notification from GS',
      },
    },
  },
  FILE_UPLOAD: {
    REMARK:
      'Upload Remark: Only accept one PDF file without any password or encryption.',
  },
  ACCEPT: 'Accept',
  DECLINE: 'Decline',
  SAVE: 'Save',
  YES: 'Yes',
  NO: 'No',
  BACK: 'Back',
  OK: 'OK',
  SUBMIT: 'Submit',
  SUBMITTED: 'Submitted',
  REMOVE: 'Remove',
  CANCEL: 'Cancel',
  UPDATE: 'Update',
  NEXT: 'Next',
  CLOSE: 'Close',
  ACCEPT_CONFIRM: {
    TITLE:
      'Are you sure you want to accept this application from this applicant?',
    CONTENT: `By accepting, you would become the applicant's chief supervisor and fill in the nomination for this application form. This action cannot be reversed.`,
  },
  DECLINE_CONFIRM: {
    TITLE:
      'Are you sure you want to decline this application from this applicant?',
    CONTENT: `By declining, the application will no longer appear in your to-do list. This action cannot be reversed.`,
  },
  SUBMIT_CONFIRM: {
    TITLE: 'Are you sure you want to submit this nomination?',
    CONTENT_CO_SUP:
      'Once submitted, other supervisor(s) will receive an email to complete the declaration of conflict of interest. Upon all supervisor(s) has/have completed the declaration, this nomination will be submitted to DoRPgS for assessment. You cannot revise this nomination.',
    CONTENT:
      'Once submitted, your nomination will be processed by DoRPgS. You cannot revise this nomination.',
  },
  DECLINE_SUCCESS: 'You have declined the nomination request.',
  PREVIEW_DIALOG: {
    TITLE: 'Preview',
    CONTENT:
      'Please note that this is a returned nomination. Kindly review the associated remarks, make the necessary modifications to your nomination, and resubmit it.',
  },
  VALIDATION_SUBMIT: {
    FILL_SUPERVISORTEAM:
      'Please ensure that at least one member in the Supervisor Team has previous successful supervision experience',
    FILL_GSB: 'Please Complete and Save the Admission Requirement',
    FILL_FUNDING: 'Please Complete and Save the Funding Source',
    CHANGE_FUNDING:
      'Please be advised that some of the selected funding options do not meet the eligibility criteria. Kindly review the selection, deselect the invalid option, and then proceed with the submission.',
    FILL_EVALUATION: 'Please Complete and Save the Evaluation',
    FILL_DECLARATION: 'Please Complete and Save the Declaration',
    FILL_REMARKS: 'Please Complete and Save the Remarks',
    SUBMIT_SUCCESS: 'Nomination Submitted Successfully.',
    SUBMIT_SUCCESS_CO_SUP:
      'Nomination Submitted Successfully. The invitation email has been sent to other supervisor(s).',
  },
  NA: 'N/A',
  SEND: 'Send',

  WRITTEN_COMMENTS_REFINE: 'Refinement of Written Comments',
};

// TODO: this is outdated and should use the newest API
export const COMMON = {
  DEPARTMENTS: {
    AP: 'Department of Applied Physics',
    ABCT: 'Department of Applied Biology and Chemical Technology',
    SFT: 'School of Fashion and Textiles',
    AF: 'School of Accounting and Finance',
    MM: 'Department of Management and Marketing',
    SHTM: 'School of Hotel and Tourism Management',
    CEE: 'Department of Civil and Environmental Engineering',
    BRE: 'Department of Building and Real Estate',
    BEEE: 'Department of Building Environment and Energy Engineering',
    LSGI: 'Department of Land Surveying and Geo-Informatics',
    EE: 'Department of Electrical and Electronic Engineering',
    EIE: 'EIE', // TODO: figure out what these are
    ME: 'Department of Mechanical Engineering',
    LMS: 'Department of Logistics and Maritime Studies',
    ISE: 'Department of Industrial and Systems Engineering',
    BME: 'Department of Biomedical Engineering',
    RS: 'Department of Rehabilitation Sciences',
    SO: 'School of Optometry',
    SN: 'School of Nursing',
    APSS: 'Department of Applied Social Sciences',
    HTI: 'Department of Health Technology and Informatics',
    COMP: 'Department of Computing',
    AMA: 'Department of Applied Mathematics',
    ENGL: 'Department of English and Communication',
    CBS: 'Department of Chinese and Bilingual Studies',
    SD: 'School of Design',
    CC: 'CC', // TODO: figure out what these are
    AAE: 'Department of Aeronautical and Aviation Engineering',
  },
};

export const SUPERVISOR_MONITOR_TEXT = {
  SUPERVISOR_MONITOR_HOME: {
    TITLE: 'Monitor',
    SUBTITLE: 'Management',
    CARD: {
      NOMINATION: 'Nomination',
      APPLICATIONS: 'Applications',
    },
  },
  SUPERVISOR_LIST: {
    PAGE_TITLE: 'Applications',
    ASSIGNED: 'Assigned',
    APPLICATION_NO: 'Application No.',
    APPLICANT_NAME: 'Applicant Name',
    PROG_LEVEL: 'Prog.Level',
    PROG: 'Prog.',
    RESEARCH_FIELD: 'Research Field',
    ENTRY_YEAR: 'Entry Year',
    SUBMISSION_TIME: 'Submission Date',
    STUDY_MODE: 'Study Mode',
    CHIEF_SUPERVISOR: 'Chief Supervisor',
    FUNDING_SCHEME: 'Funding Scheme',
    HKPFS_REFERENCE_NUMBER: 'HKPFS Ref No',
    VALID_HKPFS_APPLICATION: 'Valid HKPFS Application',
    STATUS: 'Status',
    ACTION: 'Action',
    PROGRAMME_LEVEL: {
      DOCTOR_OF_PHILOSOPHY: 'PhD',
      MASTER_OF_PHILOSOPHY: 'MPhil',
    },
    STUDY_MODE_TYPE: {
      FULL_TIME: 'FT',
      PART_TIME: 'PT',
    },
    WAITING_FOR_THE_APPLICANTS_ACCEPTANCE: "Waiting for applicant's acceptance",
    SEND_INVITATION_TITLE: 'Send Invitation',
    SEND_INVITATION_CONFIRMATION:
      'Are you sure you want to invite this applicant? This will send an email to the applicant, notifying them about your interest in supervising their application. Once the applicant accepts your invitation, you will need to start the nomination process for this applicant. Please note that this action cannot be reversed.',
    SEND_INVITATION_SUCCESS_ALERT:
      "You've successfully sent the invitation email to the applicant",
    SEND_INVITATION_WARNING_ALERT:
      'Fail to send the invitation email to the applicant',
  },
};

export const SIDEBAR_TEXT = {
  MY_NOMINATION: 'TO-DO List',
  APPLICATION_LIST: 'Application List',
  NON_PROPOSED_APPLICATION: 'Non-proposed Applications',
  CO_SUPERVISOR_DECLARATION: 'Co-supervisor Declaration',
  SHORTLISTED_HKPFS: 'Shortlisted HKPFS Nominees',
  DELEGATE_LIST: 'Delegate List',
  SCHOLARSHIP_MANAGEMENT: 'Scholarship Management',
};

export const DELEGATE_TEXT = {
  NAME: 'Name',
  NET_ID: 'Net ID',
  EMAIL: 'PolyU Email',
  DEPARTMENT: 'Department',
  START_DATE: 'Start Date',
  ROLE: 'Delegated Role',
  ACTION: 'Action',
  ADD_DELEGATOR: 'Add a New Delegator',
  DIALOG_TEXT: {
    NO_MATCHED:
      'No results found. Please check the netID or Email Address and try again.',
    DUPLICATE:
      'If the delegator already exists in your delegation list. The existing delegation will be updated.',
    ADD: 'Add',
    CLOSE: 'Close',
    PLACE_HOLDER: 'Search by NetID or PolyU Email',
    SUPERVISOR: 'Supervisor',
  },
};

export const SUPERVISOR_HOME_PAGE_TEXT = {
  MY_NOMINATION: 'TO-DO List',
  NON_PROPOSED_APPLICATION: 'Non-proposed Applications',
  APPLICATION_LIST: 'Application List',
  APPLICATIONS: 'Applications',
  DELEGATE_LIST: 'Delegate List',
  DELEGATES: 'Delegates',
};

export const POLISH_MODULE_TEXT = {
  REFEREE_NOTE:
    'Please select the two most appropriate referee reports for submission. If only two reports are available, both will be selected by default.',
};
